<template>
  <div class="modal-content-virtual-member">
    <div class="modal-header">
      <h2>Kreiranje novog servisera</h2>
    </div>
    <div class="body">
      <div id="first-section">
        <label class="col-form-label col-form-label-lg">
          Naziv
          <span class="mandatory">*</span>
        </label>
        <input
          class="form-control"
          rows="4"
          placeholder="Unesite naziv"
          v-model.trim="name"
          @focus="errorOccurred = false"
        />

        <label class="col-form-label col-form-label-lg">
          Opis
        </label>
        <input
          class="form-control"
          rows="4"
          placeholder="Unesite opis"
          v-model.trim="description"
          @focus="errorOccurred = false"
        />
        <label class="col-form-label col-form-label-lg">
          Web site
        </label>
        <input
          class="form-control"
          rows="4"
          placeholder="Unesite web site"
          v-model.trim="website"
          @focus="errorOccurred = false"
        />
        <label class="col-form-label col-form-label-lg">
          Kategorija
          <span class="mandatory">*</span>
        </label>
        <model-select
          ref="municipality"
          :options="infrastructureCategories"
          v-model="infrastructureCategory"
          placeholder="
            Izaberite kategoriju"
          class="muni-dropdown add-member-dropdown"
        ></model-select>
        <label class="col-form-label col-form-label-lg">
          Matični broj
          <span class="mandatory">*</span>
        </label>
        <input
          class="form-control"
          rows="4"
          placeholder="Unesite matični broj"
          v-model.trim="mb"
          @focus="errorOccurred = false"
        />
        <label class="col-form-label col-form-label-lg">
          PIB
          <span class="mandatory">*</span>
        </label>
        <input
          class="form-control"
          rows="4"
          placeholder="Unesite PIB"
          v-model.trim="pib"
          @focus="errorOccurred = false"
        />
        <label class="col-form-label col-form-label-lg">
          Tekući račun
          <span class="mandatory">*</span>
        </label>
        <input
          class="form-control"
          rows="4"
          placeholder="Unesite broj tekućeg računa"
          v-model.trim="accountNumber"
          v-on:blur="onAccountBlur"
          @focus="errorOccurred = false"
        />
        <div class="address-wrapper">
          <div class="address-street">
            <label class="col-form-label col-form-label-lg tooltip-label">
              Ulica (molimo izaberite ulicu iz liste)
              <span class="mandatory">*</span>
            </label>
            <div
              class="ui fluid search address-search selection dropdown add-member-dropdown active visible"
            >
              <input
                class="form-control"
                rows="4"
                placeholder="Pretraži ulicu"
                v-model.trim="addressSearchText"
                @input="debounceInput"
                @focus="addressSearchFocus = true"
                @blur="blurInput"
              />

              <div
                class="menu"
                style="display:block"
                :class="{ 'list-no-border': addressOptions.length == 0 }"
                v-if="addressSearchFocus"
              >
                <div
                  class="item"
                  v-for="addr in addressOptions"
                  :key="addr.id"
                  @click="selectAddress(addr)"
                >
                  {{ addr.street_name }}, {{ addr.municipality_name }}
                </div>
              </div>
            </div>
          </div>
          <div class="address-number">
            <label class="col-form-label col-form-label-lg">
              Broj
              <span class="mandatory">*</span>
            </label>
            <input
              class="form-control"
              rows="4"
              placeholder="Broj"
              v-model.trim="streetNumber"
              @focus="errorOccurred = false"
            />
          </div>
        </div>
        <label class="col-form-label col-form-label-lg">
          Kontakti
        </label>
        <div class="contacts" v-for="(con, index) in contacts" :key="index">
          <div style="text-align: right">
            <span class="btn btn-primary" @click="removeContact(con)">
              <i class="fas fa-minus"></i>
            </span>
          </div>
          <div class="address-wrapper">
            <div class="first-item">
              <label class="col-form-label col-form-label-lg">
                Ime
                <span class="mandatory">*</span>
              </label>
              <input
                class="form-control"
                rows="4"
                placeholder="Ime"
                v-model.trim="con.name"
                @focus="errorOccurred = false"
              />
            </div>
            <div class="second-item">
              <label class="col-form-label col-form-label-lg">
                Opis
              </label>
              <input
                class="form-control"
                rows="4"
                placeholder="Opis"
                v-model.trim="con.description"
                @focus="errorOccurred = false"
              />
            </div>
          </div>
          <div class="address-wrapper">
            <div class="first-item">
              <label class="col-form-label col-form-label-lg">
                Broj telefona
                <span class="mandatory">*</span>
              </label>
              <input
                class="form-control"
                rows="4"
                placeholder="Broj telefona"
                v-model.trim="con.phone"
                @focus="errorOccurred = false"
              />
            </div>
            <div class="second-item">
              <label class="col-form-label col-form-label-lg">
                Email
              </label>
              <input
                class="form-control"
                rows="4"
                placeholder="Email"
                v-model.trim="con.email"
                @focus="errorOccurred = false"
              />
            </div>
          </div>
        </div>
        <button
          class="btn btn-primary btn--mod add-new-contact"
          :disabled="loading"
          @click="addContact"
        >
          <p v-if="!loading">Dodaj novi kontakt</p>
        </button>
      </div>
    </div>

    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>

      <div class="buttons" style="text-align:center">
        <button
          type="submit"
          class="btn btn-danger btn--mod"
          @click="closeModal"
        >
          Otkaži
        </button>
        <button
          type="submit"
          class="btn btn-primary btn--mod"
          :disabled="loading"
          @click="addContractor"
        >
          <p v-if="!loading">Dodaj novog servisera</p>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import axios from '@/axios/axios.js';
import { utilService } from '@/util/UtilService.js';
import debounce from 'debounce';
import { ModelSelect } from 'vue-search-select';

export default {
  components: {
    ModelSelect
  },
  data() {
    return {
      errorOccurred: false,
      errorMessage: '',
      loading: false,
      allAddresses: [],
      addressOptions: [],
      selectedAddress: null,
      addressSearchText: '',
      addressSearchFocus: false,
      contacts: [],
      name: '',
      description: '',
      website: '',
      pib: '',
      mb: '',
      accountNumber: '',
      streetNumber: '',
      infrastructureCategories: [],
      infrastructureCategory: null
    };
  },
  async created() {
    this.infrastructureCategories = this.$store.state.modal.infrastructureCategories;
  },
  watch: {
    infrastructureCategory: function(data) {
      if (data.id) {
        data = {
          text: data.name,
          value: data
        };
        this.infrastructureCategory = data;
      }
    }
  },
  methods: {
    ...mapMutations('modal', ['closeModal']),
    ...mapMutations('table', ['setTableData']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapActions('table', ['getAllContractors']),

    debounceInput: debounce(function(e) {
      const searchValue = e.target.value;
      if (searchValue.includes(',')) {
        this.addressOptions = this.allAddresses.filter(street => {
          const searchString = `${street.street_name}, ${
            street.municipality_name
          }`;
          return searchString
            .toLowerCase()
            .startsWith(searchValue.toLowerCase());
        });
      } else {
        this.searchAddress(searchValue);
      }
    }, 500),
    async searchAddress(address) {
      if (address == '') {
        this.addressOptions = [];
      }
      const data = {
        municipality_id: null,
        street_name: address
      };
      const response = await axios.post('address/get-by-municipality', data);
      this.addressOptions = response.data.addresses;
      this.allAddresses = response.data.addresses;
    },

    selectAddress(addr) {
      this.addressSearchText = `${addr.street_name}, ${addr.municipality_name}`;
      this.selectedAddress = addr;
    },
    onAccountBlur() {
      const accountSepparated = this.accountNumber.split('-');
      if (accountSepparated.length != 3) {
        return;
      }
      const middleNumber = accountSepparated[1].padStart(13, '0');
      this.accountNumber = `${accountSepparated[0]}-${middleNumber}-${
        accountSepparated[2]
      }`;
    },
    blurInput() {
      setTimeout(() => {
        this.addressSearchFocus = false;
      }, 200);
    },
    addContact() {
      this.contacts.push({});
    },
    removeContact(con) {
      this.contacts = this.contacts.filter(c => c != con);
    },
    async addContractor() {
      this.errorOccurred = false;
      if (!this.validateInput()) {
        this.errorOccurred = true;
        return;
      }

      this.loading = true;
      let data = {
        name: this.name,
        description: this.description,
        webSite: this.website,
        addressId: this.selectedAddress.id,
        streetNumber: this.streetNumber,
        pib: this.pib,
        mb: this.mb,
        accountNumber: this.accountNumber,
        companyId: this.$store.getters.getCompany.id,
        infrastructureTypeId: this.infrastructureCategory.value.id
      };
      if (this.contacts.length > 0) {
        data.contacts = this.contacts;
      }
      try {
        await axios.post('contractor', data);
        await this.getAllContractors();
        this.closeModal();
        this.showSuccessModal();
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.showFailModal();
      }
    },
    validateInput() {
      if (this.name.trim() == '') {
        this.errorMessage = 'Morate uneti ime servisera';
        return false;
      }
      if (
        !this.infrastructureCategory ||
        !this.infrastructureCategory.value ||
        !this.infrastructureCategory.value.id
      ) {
        this.errorMessage = 'Morate uneti kategoriju servisera';
        return false;
      }
      if (this.pib.trim() == '') {
        this.errorMessage = 'Morate uneti PIB servisera';
        return false;
      }
      if (this.pib.trim().length > 9) {
        this.errorMessage = 'PIB servisera može imati najviše 9 karaktera';
        return false;
      }
      if (this.mb.trim() == '') {
        this.errorMessage = 'Morate uneti matični broj servisera';
        return false;
      }
      if (this.mb.trim().length > 13) {
        this.errorMessage =
          'Matični broj servisera može imati najviše 13 karaktera';
        return false;
      }
      if (this.accountNumber.trim() == '') {
        this.errorMessage = 'Morate uneti broj tekućeg računa servisera';
        return false;
      }
      if (!this.selectedAddress || this.addressSearchText.trim() == '') {
        this.errorMessage = 'Morate uneti adresu servisera';
        return false;
      }
      const addressName = `${this.selectedAddress.street_name}, ${
        this.selectedAddress.municipality_name
      }`;
      if (addressName != this.addressSearchText.trim()) {
        this.errorMessage = 'Morate izabrati ulicu iz liste';
        return false;
      }
      if (this.streetNumber.trim() == '') {
        this.errorMessage = 'Morate uneti broj ulice servisera';
        return false;
      }
      if (this.contacts.length > 0) {
        for (const contact of this.contacts) {
          if (!contact.name || contact.name.trim() == '') {
            this.errorMessage = 'Morate naziv kontakta';
            return false;
          }
          if (!contact.phone || contact.phone.trim() == '') {
            this.errorMessage = 'Morate telefon kontakta';
            return false;
          }
          if (
            contact.email &&
            contact.email.trim() != '' &&
            !utilService.isEmailValid(contact.email)
          ) {
            this.errorMessage = 'Morate uneti validnu email adresu kontakta';
            return false;
          }
        }
      }
      return true;
    }
  }
};
</script>

<style lang="scss">
.user--mod {
  .text {
    max-width: calc(100% - 30px) !important;
  }
}
.address-search {
  height: calc(2.25rem + 5px) !important;
  input {
    font-size: 1rem !important;
  }
  item {
    font-size: 1rem !important;
  }
}
.list-no-border {
  border: none !important;
}
.modal-content-virtual-member {
  .add-new-contact {
    margin-left: 0 !important;
    // margin-top: 16px;
  }
  .contacts {
    padding: 8px;
    border: 1px solid var(--primary-color);
    border-radius: 4px;
    margin-bottom: 16px;
    span.btn-primary {
      width: 4rem;
      min-width: 25px;
    }
  }
  .address-wrapper {
    display: flex;
    .address-street {
      flex: 3;
    }
    .address-number {
      flex: 1;
      margin-left: 16px;
      input {
        height: calc(2.25rem + 5px) !important;
      }
    }
    .first-item {
      flex: 1;
    }
    .second-item {
      flex: 1;
      margin-left: 16px;
    }
  }
  .input-wrapper {
    display: flex;
    width: 100%;
    position: relative;
    .user--mod {
      width: 100%;
      z-index: 5;
      margin-bottom: 2rem;
      input {
        margin-bottom: 0;
      }
      .address-search {
        width: 100%;
        line-height: 1.5;
        border-radius: 0.3rem;
        border: 1px solid #ced4da;
        font-size: 1rem;
        color: #495057;
        transition: 0.2s all;
        height: calc(2.25rem + 2px);

        // input {
        //   border: none;
        //   padding: 0.5rem 1rem;
        //   font-size: 1rem;
        //   line-height: 1;
        //   max-width: 100%;
        // }

        input:focus {
          border: none;
          outline: none;
          & {
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
        .text {
          position: absolute;
          top: 7px;
          left: 1rem;
          color: #5f5f5f;
          font-size: 1rem;
        }
        .menu {
          border: 1px solid #ced4da;
          border-radius: 0.3rem;
          border-top-width: 0;
          border-top-right-radius: 0;
          border-top-left-radius: 0;
          z-index: 11;
          background-color: white;
          max-height: 10rem;
          overflow-y: auto;
          margin: -5px -1px 0px -1px;
          .item {
            z-index: 15;
          }
          .item:hover {
            background-color: rgba(0, 0, 0, 0.05);
            cursor: pointer;
          }

          .item.selected {
            background-color: rgba(0, 0, 0, 0.178);
          }

          .btn--add {
            width: 100%;
          }
        }
      }
    }
    .add-member-dropdown {
      .menu {
        max-height: 10rem !important;
      }
    }

    .amount--mod {
      width: 100%;
      margin-bottom: 2rem;
    }

    .input-span {
      position: absolute;
      font-size: 1.5rem;
      color: rgb(95, 95, 95);
      top: 0.5rem;
      pointer-events: none;
      transition: 0.2s all;
      left: 1rem;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    input {
      margin-right: 15px;
    }

    .input--:focus ~ .input-span--name,
    .input--name:not(:placeholder-shown) ~ .input-span--name {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
      // opacity: 0;
    }

    .input--amount:focus ~ .input-span--amount,
    .input--amount:not(:placeholder-shown) ~ .input-span--amount {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
    }

    .relative {
      position: relative;
    }
  }

  .body {
    height: 100%;
    width: 100%;
  }

  input {
    margin-bottom: 9px;
    position: relative;
  }

  .btn-add-desc {
    i {
      margin-left: 4px;
    }
  }

  .desc-wrapper {
    display: flex;
    justify-content: space-between;
    span {
      margin-bottom: 9px;
      margin-left: 8px;
      min-width: 60px;
    }
  }

  .footer {
    display: block;
    width: 100%;
    text-align: center;
  }

  .buttons {
    display: inline-flex;
    float: right;
  }

  .btn--mod {
    margin-left: 15px;
  }

  .btn-primary:hover {
    background-color: var(--primary-color-lighten);
  }

  .btn-primary:active {
    background-color: var(--primary-color) !important;
    border: none;
  }

  .btn-primary:focus {
    box-shadow: 0 0 0 0.2rem var(--primary-color-lighten) !important;
  }

  .error {
    float: left;
    margin-left: 15px;
  }

  .err-msg {
    text-align: center;
    color: red;
  }

  .col-form-label-lg {
    width: 100%;
    position: relative;
  }

  .mandatory {
    color: red;
  }

  label.tooltip-label {
    display: flex;
    .mandatory {
      margin-left: 4px;
    }
    .popover {
      position: relative;
      width: fit-content;
      border: none;
      padding: 4px 4px 2px 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 1.1rem;
        color: var(--primary-color);
      }
    }
  }
}
</style>
